import React, {FC, useEffect, useState} from "react";
import {Helmet} from "react-helmet";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import {DEMO_POSTS} from "data/posts";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import SectionSliderPosts from "containers/PageHome/SectionSliderPosts";
import SectionGridPosts from "containers/PageHome/SectionGridPosts";
import SectionBlog from "./Sectionblog";
import ButtonPrimary from "../../components/Button/ButtonPrimary";
import {ArrowDownIcon, ArrowRightIcon, ArrowUpIcon} from "@heroicons/react/solid";
import ButtonSecondary from "../../components/Button/ButtonSecondary";
import {
  collectionGroup,
  doc,
  DocumentData,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  where
} from "firebase/firestore";
import {auth, db} from "../../configs/firebase-config";
import {checkBookmark, checkPostLiked} from "../../global/Functions";

DEMO_POSTS.filter((_, i) => i >= 8 && i < 16);
DEMO_POSTS.filter((_, i) => i >= 0 && i < 7);
const POSTS = DEMO_POSTS;

export interface PageBlogProps {
  className?: string;
}

let lastDocument: DocumentData | undefined | null;
const PageBlog: FC<PageBlogProps> = ({className = ""}) => {
  const [gridPostsPerPage] = useState(12);
  const [sliderPostsPerPage] = useState(8);
  const [gridPosts, setGridPosts] = useState<any>([]);
  const [sliderPosts, setSliderPosts] = useState<any>([]);
  const [lastPost, setLastPost] = useState(false);

  const getContent = async (snapshot: DocumentData) => {
    return await Promise.all(snapshot.docs.map(async (document: DocumentData): Promise<any> => {
      return {
        href: `/single/${document.get("userId")}/${document.id}`.split(" ").join('%'),
        id: document.id,
        postType: "standard",
        date: document.get("createdAt").toDate().toDateString(),
        featuredImage: document.get("image").downloadURL,
        like: {
          count: document.get("heartCount"),
          isLiked: await checkPostLiked(document.id)
        },
        bookmark: {count: 3502, isBookmarked: await checkBookmark(document.id)},
        ...document.data()
      };
    }))
  }

  const calcTimeDifference = (timestamp: number, days: number) => {
    return new Date((timestamp + (days * 24 * 60 * 60 * 1000)));
  }
  const getSliderPosts = () => {
    const time = (calcTimeDifference(Date.now(), -7));
    const q = query(
      collectionGroup(db, "posts"),
      orderBy("priority", "desc"),
      orderBy("createdAt", "desc"),
      limit(sliderPostsPerPage)
    )
    // TODO: CHANGE QUERY
    getDocs(q).then(async (snapshot) => {
      setSliderPosts(await getContent(snapshot));
    })
  }

  const getGridPosts = () => {
    const q = query(collectionGroup(db,"posts"), orderBy("createdAt", "desc"), limit(gridPostsPerPage));
    getDocs(q).then(async (snapshot) => {
      setGridPosts(await getContent(snapshot));
      lastDocument = snapshot.docs[snapshot.docs.length - 1];
    })
  }

  const loadMoreGridPosts = async () => {
    const q = (lastDocument) ?
      query(collectionGroup(db, "posts"),
        orderBy("createdAt", "desc"),
        startAfter(lastDocument),
        limit(gridPostsPerPage))
      :
      query(collectionGroup(db, "posts"),
        orderBy("createdAt", "desc"),
        limit(gridPostsPerPage))

    const snapshot = await getDocs(q);
    if (snapshot.empty){
      setLastPost(true);
      return;
    }
    setGridPosts([...gridPosts, ...await getContent(snapshot)]);
    lastDocument = snapshot.docs[snapshot.docs.length - 1];
  }

  useEffect(() => {
    getSliderPosts();
    getGridPosts();
  }, [])

  return (
    <div
      className={`PageBlog overflow-hidden relative ${className}`}
      data-id="PageBlog"
    >
      <Helmet>
        <title>Blog | CryptoVerse</title>
      </Helmet>
      <BgGlassmorphism/>
      <div className="relative overflow-hidden">

        <div className="container py-16 lg:py-28 space-y-16 lg:space-y-28">

          <SectionBlog/>
          <div className="relative py-16">

            <BackgroundSection/>
            <SectionSliderPosts
              postCardName="card7"
              sliderStype="style2"
              heading="Trending Articles"
              subHeading=" "
              posts={sliderPosts}
            />
          </div>
          <div className=" text-neutral-100">
            <div className="relative container ">
              <SectionGridPosts
                className="py-16 lg:py-28"
                postCardName="card11"
                heading="View All Articles"
                subHeading=""
                posts={gridPosts}
                gridClass="sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 lg:gap-8"
              />
            </div>
          </div>
          <div className="justify-center flex space-x-4 mt-11">

            {!lastPost ?
              <ButtonPrimary onClick={async () => {await loadMoreGridPosts()}}>
                Load More<ArrowDownIcon className="w-5 h-5 ml-2"/>
              </ButtonPrimary> :
              <ButtonPrimary onClick={() => window.scrollTo({top: 0, behavior: "smooth"})}>
                Back to Top <ArrowUpIcon className="w-5 h-5 ml-2"/>
              </ButtonPrimary>
            }
            <ButtonSecondary href={"/dashboard/submit-post"}>
              Publish An Article
              <ArrowRightIcon className="w-5 h-5 ml-2"/>
            </ButtonSecondary>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageBlog;
